export type BackgroundColors =
  | 'lava10'
  | 'ocean10'
  | 'sun10'
  | 'white'
  | 'cream'
  | 'neutral100'
  | 'acidWash'
  | 'neutral200';

export const remapDeprecatedColors = (
  color: BackgroundColors
): BackgroundColors => {
  const mapping: { [key in BackgroundColors]?: BackgroundColors } = {
    lava10: 'cream',
    ocean10: 'acidWash',
    sun10: 'neutral200',
    white: 'neutral100',
  };
  return mapping[color] || color;
};

export const breakpoints = {
  tablet: 768,
  desktop: 1230,
};
